import { I18N } from 'aurelia-i18n';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class DateLessThan45DaysOutRule implements IValidationRule {
	constructor(private i18n: I18N, private date: string) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();

		try {
			let parts = this.date.split('/');
			let day = parseInt(parts[1], 10);
			let month = parseInt(parts[0], 10);
			let year = parseInt(parts[2], 10);

			let selectedDate = new Date(year, month, day);
			let maxDate = new Date(new Date().getFullYear(), (new Date().getMonth() + 1), new Date().getDate() + 45);

			result.isValid = (selectedDate <= maxDate);
		}
		catch (err) {
			result.isValid = false;
		}

		if (!result.isValid) {
			result.errorMessage = this.i18n.i18next.t('paymentDateMustBeWithinFortyFiveDays', 'Payment Date must be less than 45 days out.');
		}

		return result;
	}
}
